
export const getCurrencyDropdownItem = ({value, label, isSelected = false, isFocused = false}) => {

    if(value?.includes?.('currency-display')){
  
      let content = label.split('') || [];
  
      let output = [];
  
      if(!content?.length){
        return;
      }
  
      for (let i = 0; i < 5; i++) {
        if(!content?.[i]){
          output.push((<span style = {{color: isSelected ? '#edebed87': isFocused ? 'white' : '#EDEBED'}}>{content[0]}</span>))
        }else{
          output.push(<span style = {{color: isSelected ? "white" : "var(--grey-95, #0C0D0D)"}}>{content[i]}</span>)
        }
      }
      return output;
    }
  
    return
  
  }